<div class="inbuilt-column-chart-v2-wrapper">
	<div *ngIf="loading" class="column-chart-state" aria-live="polite" aria-busy="true">
		<div class="spinner"></div>
		<div class="loader-text">Loading column chart...</div>
	</div>

	<div *ngIf="!loading && noDataFound" class="column-chart-state">
		No data found.
	</div>

	<div class="column-chart-scroll-area">
		<div #columnChartContainer class="column-chart-v2-container"></div>
	</div>

	<div *ngIf="!loading && showLegend" class="series-legend-row">
		<div class="legend-item" *ngFor="let item of legendItems">
			<span class="legend-color" [style.background-color]="item.color"></span>
			<span class="legend-label">{{ item.label }}</span>
		</div>
	</div>
</div>
